import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box
} from '@mui/material';
import { BUTTON_STYLES } from '../styles/componentStyles';

const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Confirm Delete",
  message = "Are you sure you want to delete this item? This action cannot be undone.",
  confirmText = "DELETE",
  confirmButtonText = "Delete",
  cancelButtonText = "Cancel",
  additionalWarning = null,
  fullScreen = false,
  maxWidth = "sm",
  fullWidth = true
}) => {
  const [deleteConfirmText, setDeleteConfirmText] = useState("");

  // Reset confirmation text when dialog opens/closes
  useEffect(() => {
    if (open) {
      setDeleteConfirmText("");
    }
  }, [open]);

  const handleClose = () => {
    setDeleteConfirmText("");
    onClose();
  };

  const handleConfirm = () => {
    if (deleteConfirmText === confirmText) {
      onConfirm();
      setDeleteConfirmText("");
    }
  };

  const isConfirmEnabled = deleteConfirmText === confirmText;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      fullScreen={fullScreen}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
      </DialogTitle>
      
      <DialogContent>
        <DialogContentText sx={{ fontSize: '1rem', lineHeight: 1.6, mb: 2, color:"#ff0000a2" }}>
          {message}
        </DialogContentText>
        
        {additionalWarning && (
          <DialogContentText sx={{ fontWeight: 550, mb: 2, color: 'warning.main' }}>
            {additionalWarning}
          </DialogContentText>
        )}
        
        <TextField
          label={`Type '${confirmText}' to confirm`}
          value={deleteConfirmText}
          onChange={(e) => setDeleteConfirmText(e.target.value)}
          fullWidth
          variant="outlined"
          size="small"
          placeholder={`Enter ${confirmText} to confirm deletion`}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button 
          onClick={handleClose} 
          variant="outlined"
          sx={{ minWidth: 100 }}
        >
          {cancelButtonText}
        </Button>
        <Button 
          onClick={handleConfirm} 
          color="error" 
          variant="contained"
          disabled={!isConfirmEnabled}
          sx={{ minWidth: 100 }}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
